import { useState } from 'react'
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth'
import { auth } from '@/lib/firebase'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

const googleProvider = new GoogleAuthProvider()

export default function Login() {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    async function handleEmail(e: React.FormEvent) {
        e.preventDefault()
        setLoading(true); setError('')
        try {
            await signInWithEmailAndPassword(auth, email, password)
            navigate('/dashboard')
        } catch {
            setError('Invalid email or password.')
        } finally { setLoading(false) }
    }

    async function handleGoogle() {
        setLoading(true); setError('')
        try {
            await signInWithPopup(auth, googleProvider)
            navigate('/dashboard')
        } catch {
            setError('Google sign-in failed. Try again.')
        } finally { setLoading(false) }
    }

    return (
        <div style={{
            minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'var(--bg)', padding: 24,
        }}>
            <div style={{ width: '100%', maxWidth: 380 }}>
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: 40 }}>
                    <div style={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        width: 52, height: 52, background: 'var(--accent)', borderRadius: 14,
                        fontSize: 24, marginBottom: 16,
                    }}>⚡</div>
                    <h1 style={{ fontSize: 24, fontWeight: 900, letterSpacing: -1, color: 'var(--text)' }}>
                        HRX Agent
                    </h1>
                    <p style={{ fontSize: 14, color: 'var(--text-muted)', marginTop: 6 }}>
                        Sign in to your HR dashboard
                    </p>
                </div>

                <div className="card">
                    {/* Google */}
                    <button className="btn btn-ghost" style={{ width: '100%', marginBottom: 20 }} onClick={handleGoogle} disabled={loading}>
                        <svg width="16" height="16" viewBox="0 0 24 24">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        Continue with Google
                    </button>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                        <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
                        <span style={{ fontSize: 11, color: 'var(--text-dim)', fontWeight: 600 }}>OR</span>
                        <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
                    </div>

                    <form onSubmit={handleEmail} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                        <div>
                            <label className="label">Email</label>
                            <input className="input" type="email" placeholder="you@company.com"
                                value={email} onChange={e => setEmail(e.target.value)} required />
                        </div>
                        <div>
                            <label className="label">Password</label>
                            <input className="input" type="password" placeholder="••••••••"
                                value={password} onChange={e => setPassword(e.target.value)} required />
                        </div>

                        {error && (
                            <div style={{ fontSize: 13, color: 'var(--red)', background: '#1a0808', border: '1px solid #3d1010', borderRadius: 8, padding: '10px 14px' }}>
                                {error}
                            </div>
                        )}

                        <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: 4 }}>
                            {loading ? <Loader2 size={16} className="spinner" /> : 'Sign In'}
                        </button>
                    </form>
                </div>

                <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--text-dim)', marginTop: 24 }}>
                    HRX Agent by <strong style={{ color: 'var(--text-muted)' }}>NEX X</strong>
                </p>
            </div>
        </div>
    )
}
